/**
 * Translates an API-supplied label by:
 *   1. trying the raw value as a key (e.g. "total_sales")
 *   2. trying a snake_case-normalized form  (e.g. "Total Sales" -> "total_sales")
 *   3. falling back to the original string when no translation exists.
 *
 * Mirrors the pattern used in DataTable.vue / FilterTypeNew.vue so dashboard
 * labels behave the same as Orders labels: translate when we have a key,
 * otherwise show the English value the backend returned.
 */
export default {
  methods: {
    normalizeApiLabel(label) {
      return String(label || "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    translateApiLabel(label) {
      if (label == null) return label;
      if (typeof label !== "string") return label;
      const raw = label.trim();
      if (!raw) return label;
      if (this.$te(raw)) return this.$t(raw);
      const normalized = this.normalizeApiLabel(raw);
      if (normalized && this.$te(normalized)) return this.$t(normalized);
      return label;
    },
  },
};
